export default "__VITE_ASSET__DF82XEUS__"